import React, { useEffect, useState } from "react";
import { Button } from "@heroui/react";
import { useLocale } from "../context/LocaleContext";
import { registerToastHandler } from "../lib/toast";

export function PortalToastHost() {
  const [toast, setToast] = useState(null);

  useEffect(() => {
    registerToastHandler((message, { isError }) => {
      setToast({ message, isError });
      window.setTimeout(() => setToast(null), 4000);
    });
    return () => registerToastHandler(null);
  }, []);

  if (!toast) return null;

  return (
    <div
      className={`portal-toast ${toast.isError ? "portal-toast--error" : "portal-toast--success"}`}
      role="status"
      aria-live="polite"
    >
      {toast.message}
    </div>
  );
}

export function PortalFormSaveBar({ isDirty, onSave, onDiscard, saving = false }) {
  const { t } = useLocale();

  if (!isDirty) return null;

  return (
    <div className="portal-save-bar" role="region" aria-label={t("common.save")}>
      <p className="portal-save-bar__label">{t("common.unsavedChanges") || "Unsaved changes"}</p>
      <div className="portal-save-bar__actions">
        <Button variant="secondary" isDisabled={saving} onPress={onDiscard}>
          {t("common.discard")}
        </Button>
        <Button variant="primary" className="portal-accent-button" isPending={saving} onPress={onSave}>
          {t("common.save")}
        </Button>
      </div>
    </div>
  );
}
